<template>
  <div class="marquee event mb-2" v-if="suKien && suKien.content">
    <div class="marquee-track">
      <span>{{ suKien.content }}</span>
      <span>{{ suKien.content }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "MarqueeEvent",
  data() {
    return {
      suKien: null,
    };
  },
  created() {
    this.getSuKien();
  },
  methods: {
    async getSuKien() {
      try {
        await this.$store.dispatch("suKienStore/getAll").then((res) => {
          if (res.data && res.data.length > 0) {
            const lastIndex = res.data.length - 1;
            this.suKien = res.data[lastIndex];
          } else {
            this.suKien = res.data;
          }
        });
      } catch (error) {
        console.error("Lỗi lấy sự kiện:", error);
      }
    },
  },
};
</script>

<style scoped>
.marquee {
  overflow: hidden;
  white-space: nowrap;
}

.marquee-track {
  display: inline-flex;
  animation: marquee 38s linear infinite;
}

.marquee-track span {
  padding-right: 50px;
  /* khoảng cách giữa 2 đoạn */
}

.marquee:hover .marquee-track {
  animation-play-state: paused;
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

/* CSS RESPONSIVE */
@media (max-width: 576px) {
  .marquee-track span {
    font-size: 13px;
    padding-right: 20px;
  }
}

@media (min-width: 577px) and (max-width: 768px) {
  .marquee-track span {
    font-size: 14px;
    padding-right: 30px;
  }
}

@media (min-width: 769px) and (max-width: 992px) {
  .marquee-track span {
    font-size: 15px;
    padding-right: 40px;
  }
}

@media (min-width: 993px) and (max-width: 1366px) {
  .marquee-track span {
    font-size: 16px;
    padding-right: 50px;
  }
}

@media (min-width: 1367px) and (max-width: 1919px) {
  .marquee-track span {
    font-size: 17px;
    padding-right: 60px;
  }
}

@media (min-width: 1920px) and (max-width: 2559px) {
  .marquee-track span {
    font-size: 18px;
    padding-right: 70px;
  }
}

@media (min-width: 2560px) {
  .marquee-track span {
    font-size: 20px;
    padding-right: 100px;
  }
}
</style>
